//import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { Container, Row, Col } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { TimeInOutThisWeek } from './TimeInOutThisWeek';
import { TimeLateThisWeek } from './TimeLateThisWeek';
import { TimeVacationLeave } from './TimeVacationLeave';
import { TimeSickDay } from './TimeSickDay';
//import { TimeInOutInfo } from "../../pages/TimeInOutInfo";
import { useTranslation } from 'react-i18next';
import { ProfileType } from '../../../model/datatype';
import { useLocation, useNavigate } from 'react-router-dom';

export const TimeInOut = (props: any) => {
  let { t } = useTranslation();
  let navigate = useNavigate();
  let location: any = useLocation();
  //console.log(location.state);

  let checkAtive = 'active1';
  if (props.renderBxo === 'none') {
    checkAtive = '';
  }
  const [active, setActive] = useState(checkAtive);
  const [data, setData] = useState<ProfileType | null>(JSON.parse(sessionStorage.getItem('obj_user_info') || '{}')); // Initialize with props.userInfo

  useEffect(() => {
    if (data === null) {
      if (location.state !== null) {
        setActive(location.state);
      }
    }
  }, [data]); // Removed getInfoUsers call

  //console.log('data', data);

  let HomeCheck = true;
  if (props.renderBxo !== 'none') {
    HomeCheck = false;
  }

  const handleClick = (id: any) => {
    setActive(id);
    navigate('/time_in_out/' + id, { state: id });
  };

  let statusActive1 = '';
  let statusActive2 = '';
  let statusActive3 = '';
  let statusActive4 = '';
  switch (active) {
    case 'active1':
      statusActive1 = 'active1';
      break;
    case 'active2':
      statusActive2 = 'active2';
      break;
    case 'active3':
      statusActive3 = 'active3';
      break;
    case 'active4':
      statusActive4 = 'active4';
      break;
  }

  return (
    <>
      {!HomeCheck ? (
        <>
          <div className="time-detail-box">
            <Container>
              <Row className="m-auto">
                <Col className=" px-1">
                  <div
                    cy-id="box-1"
                    className={
                      'time-detail-box-in-out time-in-out-box ' + statusActive1
                    }
                    onClick={() => handleClick('active1')}
                  >
                    <p className="time-detail-title">
                      {data?.totalTimeInOut}{' '}
                      {t('time_list_box.timeanddate_in_out.unit')}
                    </p>
                    <p className="time-detail-text">
                      {t('timeanddate.time_in_out')}
                    </p>
                    <img
                      src="../images/time_in_out.svg"
                      className="time-detail-img-left"
                      alt="time in out"
                    />
                  </div>
                </Col>
                <Col className=" px-1">
                  <div
                    cy-id="box-2"
                    className={
                      'time-detail-box-last-this-week time-in-out-box ' +
                      statusActive2
                    }
                    onClick={() => handleClick('active2')}
                  >
                    <p className="time-detail-title">
                      {data?.totalLates}{' '}
                      {t('time_list_box.timeanddate_late_this_week.unit')}
                    </p>
                    <p className="time-detail-text">
                      {t('timeanddate.time_late_this_week')}
                    </p>
                    <img
                      src="../images/laste_this_week.png"
                      width={52}
                      className="time-detail-img-right"
                      alt="last this week"
                    />
                  </div>
                </Col>
              </Row>
              <Row className="m-auto">
                <Col className=" px-1 mt-3">
                  <div
                    cy-id="box-3"
                    className={'time-detail-box-in-out ' + statusActive3}
                    onClick={() => handleClick('active3')}
                  >
                    <p className="time-detail-title">
                      {data?.remainVacations}{' '}
                      {t('time_list_box.timeanddate_vacation_leave.unit')}
                    </p>
                    <p className="time-detail-text">
                      {t('timeanddate.time_vacation_leave')}
                    </p>
                    <img
                      src="../images/vacation_leave.svg"
                      className="time-detail-img-left"
                      alt="vacation leave"
                    />
                  </div>
                </Col>
                <Col className=" px-1 mt-3">
                  <div
                    cy-id="box-4"
                    className={
                      'time-detail-box-stick-this-week ' + statusActive4
                    }
                    onClick={() => handleClick('active4')}
                  >
                    <p className="time-detail-title">
                      {data?.totalSickDays}{' '}
                      {t('time_list_box.timeanddate_sick.unit')}
                    </p>
                    <p className="time-detail-text">
                      {t('timeanddate.time_sick_days')}
                    </p>
                    <img
                      src="../images/sick_day.png"
                      width={52}
                      className="time-detail-img-right"
                      alt="sick day"
                    />
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </>
      ) : (
        <div className="time-detail-box">
          <Container>
            <Row className="m-auto">
              <Col className=" px-0">
                <div
                  cy-id="box-1"
                  className={
                    'time-detail-box-in-out time-in-out-box ' + statusActive1
                  }
                  onClick={() => handleClick('active1')}
                >
                  <p className="time-detail-title">
                    {data?.totalTimeInOut}{' '}
                    {t('time_list_box.timeanddate_in_out.unit')}
                  </p>
                  <p className="time-detail-text">
                    {t('timeanddate.time_in_out')}
                  </p>
                  <img
                    src="../images/time_in_out.svg"
                    className="time-detail-img-left"
                    alt="time in out"
                  />
                </div>
              </Col>
              <Col className=" px-0">
                <div
                  cy-id="box-2"
                  className={
                    'time-detail-box-last-this-week time-in-out-box ' +
                    statusActive2
                  }
                  onClick={() => handleClick('active2')}
                >
                  <p className="time-detail-title">
                    {data?.totalLates}{' '}
                    {t('time_list_box.timeanddate_late_this_week.unit')}
                  </p>
                  <p className="time-detail-text">
                    {t('timeanddate.time_late_this_week')}
                  </p>
                  <img
                    src="../images/laste_this_week.png"
                    width={52}
                    className="time-detail-img-right"
                    alt="last this week"
                  />
                </div>
              </Col>
            </Row>
            <Row className="m-auto">
              <Col className=" px-0 mt-3">
                <div
                  cy-id="box-3"
                  className={'time-detail-box-in-out ' + statusActive3}
                  onClick={() => handleClick('active3')}
                >
                  <p className="time-detail-title">
                    {data?.remainVacations}{' '}
                    {t('time_list_box.timeanddate_vacation_leave.unit')}
                  </p>
                  <p className="time-detail-text">
                    {t('timeanddate.time_vacation_leave')}
                  </p>
                  <img
                    src="../images/vacation_leave.svg"
                    className="time-detail-img-left"
                    alt="vacation leave"
                  />
                </div>
              </Col>
              <Col className=" px-0 mt-3">
                <div
                  cy-id="box-4"
                  className={'time-detail-box-stick-this-week ' + statusActive4}
                  onClick={() => handleClick('active4')}
                >
                  <p className="time-detail-title">
                    {data?.totalSickDays}{' '}
                    {t('time_list_box.timeanddate_sick.unit')}
                  </p>
                  <p className="time-detail-text">
                    {t('timeanddate.time_sick_days')}
                  </p>
                  <img
                    src="../images/sick_day.png"
                    width={52}
                    className="time-detail-img-right"
                    alt="sick day"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}

      {!HomeCheck ? (
        (() => {
          switch (active) {
            case 'active1':
              return <TimeInOutThisWeek email={data?.email} />;
            case 'active2':
              return <TimeLateThisWeek email={data?.email} />;
            case 'active3':
              return <TimeVacationLeave email={data?.email} />;
            case 'active4':
              return <TimeSickDay email={data?.email} />;
            default:
              if (props.renderBxo !== 'none') {
                return <TimeInOutThisWeek email={data?.email} />;
              }
          }
        })()
      ) : (
        <></>
      )}
    </>
  );
};
